import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import axios from 'axios';
import "../index.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIosNew';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function StudyInJapan() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [location, setLocation] = useState('Online');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [activePage, setActivePage] = useState("Go Japan");
  const navigate = useNavigate();
  const authToken = localStorage.getItem("AuthToken");
  const { username } = useContext(ProductContext);
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);
  const handleConfirm = async () => {
    if (!selectedDate || !selectedTime) {
      alert("Please select both a date and time.");
      return;
    }

    const formattedDate = selectedDate.toLocaleDateString('en-CA'); // Format date as YYYY-MM-DD
    const data = {
      location,
      date: formattedDate,
      time: selectedTime,
      name: name?.message?.userDetails?.name, // Extract from userDetails
      email: email?.message?.userDetails?.email  // Extract from userDetails
    };


    try {
      const response = await fetch('https://api.japaking.online/api/journey', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(data)
      });
      console.log("print response", response);
      if (response.ok) {

        console.log('Data sent', data);
        navigate("/thank-you");
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        console.log("Navigate to login due to 401");
        navigate("/login");
      } else {
        console.log('Error sending data:', err);
      }
    }
  };

  const times = [
    "08:00 AM", "08:30 AM", "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM",
    "11:00 AM", "11:30 AM", "12:00 PM", "01:30 PM", "02:30 PM", "03:30 PM",
    "04:30 PM", "05:30 PM", "06:30 PM", "07:30 PM", "08:30 PM", "10:30 PM"
  ];

  const today = new Date();

  return (
    <div className='Profile_Design_Main_Div_11'>
      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />

              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="study-in-japan-container">
        <div className='col-md-12'>
          <h5>{Translate?.message?.data?.scheduleYourSessionToStartYourJourneyTo || "Schedule Your Session to start your journey to"}</h5>
        </div>
        <div className="form-group">

          <label className="form-label">{Translate?.message?.data?.personName || "Person Name"}</label>
          <input type="text" value={username?.message?.userDetails?.name} placeholder="Enter your name" disabled />
        </div>

        <div className="form-group">
          <label className="form-label">{Translate?.message?.data?.email || "Email"}</label>
          <input type="email" value={username?.message?.userDetails?.email} placeholder="Enter your email" disabled />
        </div>

        <div className="form-group">
          <label className="form-label">{Translate?.message?.data?.location || "Location"}</label>
          <select value={location} onChange={(e) => setLocation(e.target.value)}>
            <option value="Online">{Translate?.message?.data?.online || "Online"}</option>
            <option value="Delhi Office">{Translate?.message?.data?.delhiOffice || "Delhi Office"}</option>
            <option value="Tokyo Office">{Translate?.message?.data?.tokyoOffice || "Tokyo Office"}</option>
          </select>
        </div>

        <div className="form-group date-picker-group">
          <label className="form-label">{Translate?.message?.data?.date || "Date"}</label>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            minDate={today}
            inline
            dateFormat="yyyy-MM-dd"
            className="date-picker"
            calendarClassName="custom-calendar"
          />
        </div>

        <div className="form-group">
          <label className="form-label">{Translate?.message?.data?.time || "Time"}</label>
          <div className="time-slots">
            {times.map((time, index) => (
              <button
                key={index}
                className={`time-slot ${selectedTime === time ? 'selected' : ''}`}
                onClick={() => setSelectedTime(time)}
              >
                {time}
              </button>
            ))}
          </div>
        </div>

        <button className="confirm-button" onClick={handleConfirm}>{Translate?.message?.data?.confirm || "Confirm"}</button>
      </div>
      <Footer />
    </div>
  );
}

export default StudyInJapan;
